module.exports = __webpack_public_path__ + "img/skyline.57d01024.png";